import './index.css'

import { ThemeProvider } from '@material-ui/styles'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import reportWebVitals from './reportWebVitals'
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { isSilentRenewUrl } from './utils/authUrlUtils'
import {
  ensureTenantInUrl,
  getCachedTenant,
  getTenantFromPath,
} from './utils/tenantUtils'

if (isSilentRenewUrl()) {
  // Render ONLY the lightweight silent renew component in the hidden iframe.
  // Avoids loading Redux and the main app which would start their own
  // oidc-client-ts instances and trigger an exponential loop of nested iframes.
  import('./presentation/SilentRenew')
    .then(({ default: SilentRenew }) => {
      ReactDOM.render(<SilentRenew />, document.getElementById('root'))
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load SilentRenew component:', error)
    })
} else if (ensureTenantInUrl()) {
  // If the URL is missing the tenant prefix (e.g. /talent-profile or /),
  // ensureTenantInUrl() redirects via window.location.replace to /{tenant}{pathname}.
  // Skip mounting at the un-prefixed URL to avoid double rendering and racing API calls.
} else {
  // Initiate user loading immediately after the store is ready.
  // If the user has a valid session in localStorage, it is dispatched to Redux.
  // If not, or if the token has expired, a signinRedirect() to the Retain IdP is
  // triggered. On the /callback path, the OIDC code exchange is processed first.
  Promise.all([
    import('./App'),
    import('./guard/TenantGuard'),
    import('./authentication/authenticationHandlers'),
    import('./redux'),
    import('./themes'),
  ])
    .then(
      ([
        { default: App },
        { default: TenantGuard },
        { loadUser },
        { default: store },
        { default: themes },
      ]) => {
        // Only start the user load when the URL tenant and the cached tenant
        // agree. If they differ, TenantGuard is about to run a signoutRedirect
        // on mount; calling loadUser() as well would put two top-level
        // navigations in flight at once, and if the signin won the user would
        // be re-authenticated into the OLD tenant and the guard would fire
        // again on the next load. TenantGuard owns the navigation in that case.
        const urlTenant = getTenantFromPath()
        const knownTenant = getCachedTenant()
        const tenantSwitchPending =
          urlTenant && knownTenant && urlTenant !== knownTenant

        if (!tenantSwitchPending) {
          loadUser(store, window.location.pathname, window.localStorage)
        }

        ReactDOM.render(
          <Provider store={store}>
            <ThemeProvider theme={themes.default}>
              <TenantGuard>
                <App />
              </TenantGuard>
            </ThemeProvider>
          </Provider>,
          document.getElementById('root'),
        )
      },
    )
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load application components:', error)
      ReactDOM.render(
        <div
          style={{
            padding: '2rem',
            textAlign: 'center',
            fontFamily: 'sans-serif',
          }}
        >
          <h2>Application Error</h2>
          <p>
            Failed to load essential components. Please check your network
            connection and refresh the page.
          </p>
        </div>,
        document.getElementById('root'),
      )
    })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
// serviceWorkerRegistration.register()
